export default __webpack_public_path__ + "static/media/company logo3.713f4031.svg";